<template>
  <div style="padding-top: 4px;background: #000;box-sizing: border-box;">
    <!-- 查看200档实时成交 -->
    <div id="TransViewMore">
      <div class="TransViewMore-header">
        <div class="newHeader">
          <div class="fBack">
            <i class="el-icon-arrow-left" @click="routerback"></i>
          </div>
          <div class="title">
            <span> {{ selectItem.commodityCode }} </span>
            <span> {{ selectItem.symbol }} </span>
            <span> 成交明细</span>
          </div>
          <div class="searchInput">
            <span style="font-size:16px;color: #DFDFDF;font-weight: 400;margin-right:19px">大单筛选</span>
            <div class="ipt">
              <input
                v-model="pdnum"
                ref="prices"
                class="select-i"
                step="0.01"
                placeholder="请输入每笔成交量"
                @input="limitInput"
              >
              <i style="display:inline-block;font-size:10px;color:rgba(152, 152, 152, 1);width:10px;height:10px" class="el-icon-search" @click="changeSelect"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 标注 时间 价格 方向 -->
      <!-- <div class="TransViewMore-toptitle">
        <ul
          v-for="i in 5"
          :key="`TransViewMore-toptitle--${i}`"
          class="sm-title"
        >
          <li style="text-align: left">时间</li>
          <li style="text-align: left" class="mid">价格</li>
          <li class="rightli">数量&nbsp;&nbsp;&nbsp;</li>
        </ul>
        <ul class="sm-title"></ul>
      </div> -->
      <div class="TransViewMore-scroll">
        <div class="TransViewMore-outbox">
          <!-- 实时成交信息 -->
          <div 
            class="TransViewMore-box right-line" 
            v-for="i in pageNum"
            :key="`TransViewMore-toptitle--${i}`">
            <ul class="sm-title">
              <li>时间</li>
              <li>价格</li>
              <li>数量</li>
            </ul>
            <TransView
              :list-data="transDatas[i - 1]"
              :start-index="i * sizeNum"
              :current-index="currentIndex"
              @transViewClick="transViewClick"
            />
          </div>
          <!-- <div class="TransViewMore-box right-line">
            <TransView
              :list-data="transDatas1"
              :start-index="41"
              :current-index="currentIndex"
              @transViewClick="transViewClick"
            />
          </div>
          <div class="TransViewMore-box right-line">
            <TransView
              :list-data="transDatas2"
              :start-index="81"
              :current-index="currentIndex"
              @transViewClick="transViewClick"
            />
          </div>
          <div class="TransViewMore-box right-line">
            <TransView
              :list-data="transDatas3"
              :start-index="121"
              :current-index="currentIndex"
              @transViewClick="transViewClick"
            />
          </div>
          <div class="TransViewMore-box right-line">
            <TransView
              :list-data="transDatas4"
              :start-index="161"
              :current-index="currentIndex"
              @transViewClick="transViewClick"
            />
          </div> -->
          <div class="TransViewMore-tab3 TransViewMore-box">
            <div class="TransViewMore-tab3-box1" style="height: 228px">
              <!-- 委托列表 -->
              <TopViewCC />
            </div>
            <div class="line-box"></div>
            <div class="TransViewMore-tab3-box2" style="height: 220px">
              <!-- 盘口明细 -->
              <NewGoodsMsg style="height: 220px" />
            </div>
            <div class="TransViewMore-tab3-box3" style="height: 390px">
              <!-- 公告 -->
              <NoticeCC />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global hqProtocol hqWs */
import { mapGetters } from 'vuex'
// import NoticeCC from './notice/NoticeCC'
// import CoinInfo from './coininfo/CoinInfo'
// import RealTimeTrans from './realtimetrans/RealTimeTrans'
import TopViewCC from './topview/TopViewCC'

import NoticeCC from './notice/transNotice'

import NewGoodsMsg from './new/NewGoodsMsg.vue'
// 展示信息
import TransView from './transview/transView.vue'
/* eslint-disable vue/no-side-effects-in-computed-properties */
export default {
  name: 'TransViewMore',
  components: {
    // CoinInfo,
    // RealTimeTrans,
    TopViewCC,
    NoticeCC,
    NewGoodsMsg,
    TransView
  },
  data() {
    return {
      pageNum: 5, // 总共多少列 从1开始
      sizeNum: 40, // 每列展示多少条数据 从1开始
      totle: 0, // 每列展示多少条数据 从1开始
      pdnum: '', // 限定搜索 每笔成交量
      param_realtime_200: {}, // 记录信息
      param_realtime: {}, // 修改查询接口
      // 一下为transView需要的字段
      items: [],
      currentIndex: null, // 点击选中的index 从1开始
      auxiliaryValue: 0, // 辅助计算获取数据源的值
      timer: null, // 防抖
      isHis: false, // 防抖
      loadHis: false // 标记处理历史数据
    }
  },
  computed: {
    ...mapGetters([
      'item',
      'marketDetails',
      'pricedetail', // TODO 替换为 pricedetail_big
      'commodityStrategyGetter',
      'sessionInfoGetter'
    ]),
    transDatas() {
      const arr = [[], [], [], [], []]
      if (!this.items || this.items.length === 0) {
        return arr
      }
      // this.items.reverse()
      // if (this.items.length < 41) {
      //   arr[0] = this.items
      // } else if (this.items.length < 81) {
      //   arr[0] = this.items.slice(0, 40)
      //   arr[1] = this.items.slice(40, this.items.length)
      // } else if (this.items.length < 121) {
      //   arr[0] = this.items.slice(0, 40)
      //   arr[1] = this.items.slice(40, 80)
      //   arr[2] = this.items.slice(80, this.items.length)
      // } else if (this.items.length < 161) {
      //   arr[0] = this.items.slice(0, 40)
      //   arr[1] = this.items.slice(40, 80)
      //   arr[2] = this.items.slice(80, 120)
      //   arr[3] = this.items.slice(120, this.items.length)
      // } else 
      if (this.items.length <= this.totle) {
        const num = Math.ceil(this.items.length / this.sizeNum)
        for(let i = 0; i <= num; i++) {
          if (i === num) {
            arr[i] = this.items.slice(i * this.sizeNum, this.items.length)
          } else {
            arr[i] = this.items.slice(i * this.sizeNum, (i + 1) * this.sizeNum)
          }
        }
      } else {
        for(let i = 0; i < this.pageNum; i++) {
            arr[i] = this.items.slice(i * this.sizeNum + this.auxiliaryValue, (i + 1) * this.sizeNum + this.auxiliaryValue)
        }
        // arr[0] = this.items.slice(this.auxiliaryValue, 40 + this.auxiliaryValue)
        // arr[1] = this.items.slice(
        //   40 + this.auxiliaryValue,
        //   80 + this.auxiliaryValue
        // )
        // arr[2] = this.items.slice(
        //   80 + this.auxiliaryValue,
        //   120 + this.auxiliaryValue
        // )
        // arr[3] = this.items.slice(
        //   120 + this.auxiliaryValue,
        //   160 + this.auxiliaryValue
        // )
        // arr[4] = this.items.slice(
        //   160 + this.auxiliaryValue,
        //   200 + this.auxiliaryValue
        // )
      }
      return arr
    },
    // transDatas0() {
    //   return this.transDatas[0]
    // },
    // transDatas1() {
    //   return this.transDatas[1]
    // },
    // transDatas2() {
    //   return this.transDatas[2]
    // },
    // transDatas3() {
    //   return this.transDatas[3]
    // },
    // transDatas4() {
    //   return this.transDatas[4]
    // },
    isLogin() {
      if (
        this.sessionInfoGetter &&
        this.sessionInfoGetter['sessionStr'] &&
        this.sessionInfoGetter['userId']
      ) {
        return true
      }
      return false
    },
    selectItem() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        for (
          let index = 0;
          index < this.$store.state.hqData.marketDetails.length;
          index++
        ) {
          const element = this.$store.state.hqData.marketDetails[index]
          if (this.$store.state.hqData.item.symbolId == element.symbolId) {
            return element
          }
        }
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0]
        } else {
          return {
            close: 0.0,
            quotechangeColor: 'white',
            quotechange: 0.0,
            high: 0,
            low: 0,
            amount: 0,
            symbolId: '--',
            clearPrice: 0
          }
        }
      }
      return ''
    },
    data() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    ceshiXh: function() {
      const itemHx = this.item.symbolId
      if (itemHx) {
        return itemHx
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    unit() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[1]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[1]
        } else {
          return '--'
        }
      }
    },
    units() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[0]

        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[0]
        } else {
          return '--'
        }
      }
    }
  },
  watch: {
    ceshiXh(xin, jiu) {
      this.realtimeTrade(this.ceshiXh)
    },
    pricedetail(news, old) {
      this.showOrderData()
    },
    pdnum(val) {
      if (!val) {
        hqProtocol.param_unsubscribereq.contractIds = [this.selectItem.symbolId]
        hqWs.send(hqProtocol.param_unsubscribereq)
      }
    },
    items(newv, oldv) {
      if (oldv.length === 0) {
        this.auxiliaryValue = newv.length - 200
      }
      if (oldv.length && this.auxiliaryValue === oldv.length - 200) {
        this.auxiliaryValue = newv.length - 200
      }
      // 判断当前为历史数据更新
      if (oldv.length && oldv[0].occurTime != newv[0].occurTime && this.loadHis) {
        this.auxiliaryValue = this.auxiliaryValue + (newv.length - oldv.length)
      }
      // 判断为加载筛选数据
      if (oldv.length && oldv[0].occurTime != newv[0].occurTime && !this.loadHis) {
        this.auxiliaryValue = newv.length - 200
      }
    }
  },
  created() {
    this.totle = Number(this.util.floatMul(this.pageNum, this.sizeNum))
    const shuju = this.ceshiXh
    this.realtimeTrade(shuju)
    this.showOrderData()
    // 实时成交信息
    this.param_realtime_200 = {
      'fid': 'pricedetail-req',
      'singleQuantity': '',
      'marketId': 111,
      'contractId': hqProtocol.param_realtime.contractId,
      'bCtrl': 1,
      'positionIndex': -500,
      'count': 500
    }
    this.param_realtime = {
      'fid': 'pricedetail-req',
      'singleQuantity': '',
      'marketId': 111,
      'contractId': hqProtocol.param_realtime.contractId,
      'bCtrl': 1,
      'positionIndex': -500,
      'count': 500
    }
    // 订阅信息
    this.param_subscribe_200 = JSON.parse(
      JSON.stringify(hqProtocol.param_subscribe)
    )
    hqWs.send(this.param_realtime)
  },
  mounted() {
    // 监听鼠标滚动事件
    window.addEventListener('wheel', this.handleScroll, true) ||
      window.addEventListener('DOMMouseScroll', this.handleScroll, false)
    const _this = this
    // 鉴定键盘输入
    document.onkeydown = function(e) {
      const evn = e || event
      const key = evn.keyCode || evn.which || evn.charCode
      // 上
      if (key === 38) {
        _this.handleScroll({ deltaY: -1 })
      }
      // 下
      if (key === 40) {
        _this.handleScroll({ deltaY: 1 })
      }
    }
    document.onkeyup = function(e) {
    }
  },
  beforeDestroy() {
    // 离开页面请求消息覆盖本页查询
    // 请求实时成交信息
    hqWs.send(hqProtocol.param_realtime)
    // 订阅
    hqWs.send(hqProtocol.param_subscribe)
    hqProtocol.param_unsubscribereq.contractIds = [this.selectItem.symbolId]
    hqWs.send(hqProtocol.param_unsubscribereq)
    // ! 取消筛选
  },
  methods: {
    transViewClick(index) {
      if (this.currentIndex === index) {
        this.currentIndex = null
      } else {
        this.currentIndex = index
      }
    },
    // 判断滚动方向
    handleScroll(e) {
      if (this.currentIndex === null) {
        return
      }
      const direction = e.deltaY > 0 ? 'down' : 'up'
      if (this.currentIndex <= 1) {
        direction == 'down' ? this.currentIndex++ : (this.currentIndex = 1)
        if (direction == 'up' && this.items.length > 200) {
          // 减
          this.auxiliaryValue <= 0
            ? (this.auxiliaryValue = 0)
            : this.auxiliaryValue--
        }
      } else if (this.currentIndex >= 200) {
        direction == 'down' ? (this.currentIndex = 200) : this.currentIndex--
        if (direction == 'down' && this.items.length > 200) {
          // 加
          this.auxiliaryValue >= this.items.length - 200
            ? (this.auxiliaryValue = this.items.length - 200)
            : this.auxiliaryValue++
        }
      } else {
        direction == 'down' ? this.currentIndex++ : this.currentIndex--
      }
      // 判断选中为第一条且手势上划发起历史数据请求
      if (this.currentIndex <= 1 && this.auxiliaryValue == 0 && direction == 'up') {
        // TODO 请求历史数据
        if (this.timer) {
          clearTimeout(this.timer)
        }
        if (!this.isHis) {
          const his_realtime = JSON.parse(
            JSON.stringify(this.param_realtime)
          )
          his_realtime.itemNum = this.items[0].itemNum
          hqWs.send(his_realtime)
          this.loadHis = true // 标记已请求历史
        } else {
          this.timer = setTimeout(() => {
            this.isHis = false
          }, 500)
        }
      }
    },
    routerback() {
      if (!this.isLogin) {
        // 未登录
        this.$router.push('/transccless')
      } else {
        this.$router.push('/transcc')
      }
    },
    changeSelect() {
      // TODO 发送请求,订阅并判断信息
      if (this.pdnum === '') {
        hqWs.send(this.param_realtime)
        return
      }
      var re = /^[0-9]+.?[0-9]*/ // 判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
      if (!re.test(this.pdnum) || !Number(this.pdnum) > 0) {
        this.$message('输入类型错误')
        return
      }
      // pricedetail-req传参double singleQuantity;//成交量
      this.param_realtime_200.singleQuantity = this.pdnum
      hqWs.send(this.param_realtime_200)
      // ! 缺少订阅函数,需要向行情服务发送带"大单筛选"的参数
      hqProtocol.param_big_top.singleQuantity = this.pdnum
      hqProtocol.param_big_top.symbol = this.selectItem.symbolId
      hqWs.send(hqProtocol.param_big_top)
    },
    limitInput() {
      const numStr = this.pdnum
      if (this.$refs.prices.value) {
        if (this.$refs.prices.value.length >= 2) {
          this.$refs.prices.value = this.$refs.prices.value.replace(
            numStr,
            '$1.$2'
          )
          this.price = this.$refs.prices.value
        } else {
          this.$refs.prices.value = this.$refs.prices.value.replace(/[^0-9]/g, '')
          this.price = this.$refs.prices.value
        }
      }
    },
    realtimeTrade: function(data) {
      this.param_realtime.contractId = data
      this.param_realtime_200.contractId = data
      // 因爲只有test1數據
      // this.param_realtime.contractId = 'Test1'
      hqWs.send(this.param_realtime)
    },
    DateFormate: function(timer) {
      //   var timezone = 8; //目标时区时间，东八区
      // var offset_GMT = new Date().getTimezoneOffset();
      // var offset_GMT_Time = -offset_GMT/60;
      // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
      const date = new Date(timer)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var min = date.getMinutes()
      var sec = date.getSeconds()
      ;[year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
      ].map((item) => (item < 10 ? '0' + item : item))
      // return `${year}-${month}-${day} ${hour}:${min}:${sec}`
      return `${hour}:${min}:${sec}`
    },

    showOrderData: function() {
      let aData = []
      if (!this.pricedetail) {
        return
      }
      // for (let i = 0; i < this.pricedetail.length; i++) {
      //   // 实时更新对应币种的数据
      //   if (this.item.symbolId) {
      //     if (this.pricedetail[i].contractId == this.item.symbolId) {
      //       aData.push(this.pricedetail[i])
      //     } else {
      //       console.log('发现错误行情数据', this.pricedetail[i])
      //     }
      //   } else {
      //     if (
      //       this.pricedetail[i].contractId == this.marketDetails[0].symbolId
      //     ) {
      //       aData.push(this.pricedetail[i])
      //     } else {
      //       console.log('发现错误行情数据', this.pricedetail[i])
      //     }
      //   }
      // }
      aData = this.pricedetail
      // if (aData.length > 17) {
      //   aData.slice(0, 16)
      // }
      this.items = JSON.parse(JSON.stringify(aData))
      // this.items.reverse()
      for (const i in aData) {
        // 时间
        const timeStamp = aData[i].occurTime
        const timeStampInt = parseInt(timeStamp)
        this.items[i].dates = this.$options.methods.DateFormate(timeStampInt)
        // this.items[i].dates = this.items[i].dates.slice(10);
        // 方向
        if (aData[i].ioFlag == '0') {
          this.items[i].upDown = '买入'
        } else if (aData[i].ioFlag == '1') {
          this.items[i].upDown = '卖出'
        }
        // 價格
        this.items[i].prices = aData[i].price
        // 数量
        this.items[i].volumn = aData[i].volume
      }
      this.items.reverse()
    }
  }
}
</script>
<style scoped lang="scss">
#TransViewMore {
  background: #121212;
  // margin-top: 4px;
  .TransViewMore-header {
    height: 58px;
    position: absolute;
    border-bottom: 1px solid #1c1c1c;
    background: #121212;
    z-index: 1001;
    width: 100%;
    .fBack {
      display: flex;
      align-items: center;
      i {
        font-size:22px;
        cursor: pointer;
        color:#ffffff;
      }
      div {
        height: 22px;
        margin-left: 18px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 16px;
        color: #DFDFDF;
      }
      // position: absolute;
      // left: 41px;
      // top: 18px;
    }
    .newHeader {
      height: 100%;
      display: flex;
      justify-content: space-between;
      margin: 0 40px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      .title{
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
      }
      .searchInput{
        display: flex;
        align-items: center;
        height: 100%;
        box-sizing: border-box;
        .ipt{
          width: 210px;
          height: 30px;
          display: flex;
          padding: 0 10px;
          justify-content: space-between;
          align-items: center;
          border-radius: 2px;
          border: 1px solid rgba($color: #ffffff, $alpha: 0.2);
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #989898;
          .select-i::placeholder {
            font-family: Source Han Sans SC;
            font-weight: 400;
            font-size: 12px;
            color: #989898;
          }
        }
      }
    }
    /deep/ .el-row .el-col {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 29px;
    }
    .select-t {
      font-size: 16px;
    }
    .select-i {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 12px;
      color: #989898;
      background: transparent;
      box-shadow: none;
      // border: 1px solid #979797;
      border: none;
      flex: 1;
    }
  }
  .TransViewMore-scroll {
    height: calc(100vh - 123px);
    overflow-y: scroll;
    padding-top: 58px;
  }
  .TransViewMore-toptitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 26px;
    width: 100%;
    height: 40px;
    // background: linear-gradient(
    //   180deg,
    //   rgba(36, 42, 67, 0.6) 0%,
    //   #2e3453 52%,
    //   rgba(48, 54, 82, 0.8) 100%
    // );
    // background: #141517;
    // box-shadow: 0px 2px 4px 0px rgba(255, 255, 255, 0.2);
   
  }

  .TransViewMore-outbox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    // height: 1032px;
    padding-bottom: 20px;
    // min-height: 9px;
    .TransViewMore-box {
      width: 30%;
      flex: 1;
      height: 100%;
      .sm-title {
        padding: 10px 0 10px;
        width: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 16px;
        color: #DFDFDF;
        justify-content: space-between;
        li {
          flex: 1;
          text-align: center;
          // width: 40%;
        }
        // .mid {
        //   width: 30%;
        // }
        // .rightli {
        //   width: 30%;
        // }
      }
    }
    .TransViewMore-tab3 {
      min-width: 276px;
    }
    .line-box {
      height: 1px;
      background: rgba($color: #ffffff, $alpha: 0.3);
    }
    .TransViewMore-tab3-box1 {
     
      padding-bottom: 15px;
    }
    .TransViewMore-tab3-box2 {
      position: relative;
      padding-top: 16px;
    }
  }
  .TransViewMore-box.right-line {
    border-right: 1px solid #5a5a5a;
  }
}
</style>
